import { render, staticRenderFns } from "./PointsExchange.vue?vue&type=template&id=9904c9ba&scoped=true&"
import script from "./PointsExchange.vue?vue&type=script&lang=js&"
export * from "./PointsExchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9904c9ba",
  null
  
)

export default component.exports